import { httpClient } from 'core/net/http';
import HttpResponse from 'core/net/HttpResponse';

export async function deleteBlastingScenario(alias: string): Promise<HttpResponse> {
  const response = await httpClient.useInternalApi.asAuthorised().delete(`configuration/blasting/scenarios/${alias}`);
  if (!response.isSuccess) throw new Error('Failed to delete blasting scenario');
  return response;
}
